// import { createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";

// export const getGame = createAsyncThunk(
//   "game/getGame",
//   async (slug, { rejectWithValue }) => {
//     try {
//       const { data } = await axios.get(
//         `${process.env.REACT_APP_API_SERVER_URL}/game/slug/${slug}?platform=B2BW&language=en`
//       );
//       return data;
//     } catch (error) {
//       return rejectWithValue(error.message || "Something went wrong");
//     }
//   }
// );

import {apiSlice} from '../api/apiSlice'

export const gameSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getGame: builder.mutation({
            query: ({slug, access_token}) => ({
                url: `/game/slug/${slug}?platform=B2BW&language=en&access_token=${access_token}`,
                method: 'GET',
            }),
        }),
    }),
})

export const multiplayerSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        registerPlayWithStranger: builder.mutation({
            query: (data) => ({
                url: `/game/${data.uuid}/multiplayer/play-with-strangers`,
                method: 'POST',
                headers: {
                    "userid": data.userId
                },
                body: {
                    "Name": data.name,
                    "Avatar": data.avatar,
                }
            }),
        }),
    }),
})


export const {useGetGameMutation} = gameSlice
export const {useRegisterPlayWithStrangerMutation} = multiplayerSlice
